export const mapbp = {
  api_key:
    "pk.eyJ1IjoicnVpcGdzIiwiYSI6ImNreTh6aGJwdDAxaHczMG8zbnd5MWxhbjkifQ.-Y29-W-tOPS5JZMaqBRiJA",
  style: "mapbox://styles/ruipgs/clpfirdnx00fs01o035qt9fwq?optimize=true",
  bwStyle: "mapbox://styles/ruipgs/cl6j70lku000b14o7whq3vh68?optimize=true",
  bounds: [
    //longitude, latitude
    [-8.832036, 41.020626],
    [-8.370565, 41.32765],
  ],
  boundsExplicit: {
    minLong: -8.727914507804241,
    maxLong: -8.491212,
    minLat: 41.10302201425525,
    maxLat: 41.218339,
  },
  startingPosition: {
    lng: -8.608094,
    lat: 41.155071,
    zoom: 14,
  },
  layers: {
    spaces: {
      id: "spaces_id",
      type: "symbol",
      source: "spaces",
      //NAME OF LAYER IN STYLE, NOT ORIGIN, BUT NEEDS TO BE THE SAME!
      // sourceLayer: "spaces-22-03-2022-4jnf47",
      // url: "mapbox://ruipgs.922trbp8",
      // sourceLayer: "spaces-23-03-2022-90vglj",
      // url: "mapbox://ruipgs.0z1nq1vw",
      sourceLayer: "spaces-23-03-2022-cpjt34",
      url: "mapbox://ruipgs.49e50k74",
    },
  },
};

export const isInBounds = (coordinates) => {
  return (
    coordinates &&
    coordinates[0] > mapbp.bounds[0][0] &&
    coordinates[0] < mapbp.bounds[1][0] &&
    coordinates[1] > mapbp.bounds[1][0] &&
    coordinates[1] < mapbp.bounds[1][1]
  );
};

export const inaugrationCategory = "inauguration";
export const stateCategory = "state";
export const typologyCategory = "typology";
export const formatCategory = "format";
export const practiceCategory = "practice";
export const stateKeys = {
  open: "Em Funcionamento",
  closed: "Encerrado Permanentemente",
};

export const inaugurationKeys = {
  y80: "1980",
  y90: "1990",
  y00: "2000",
  y10: "2010",
  y20: "2020",
};

export const typologyKeys = {
  artist_run: "Espaços geridos por artistas",
  exhibition: "Espaços Expositivos",
  curatorial: " Projetos Curatoriais",
  studio: "Estúdios e Ateliers",
  collective: "Coletivos",
  residency: "Residências",
  editorial: "Livrarias, Bibliotecas e Editoras",
  digital_platform: "Plataformas Digitais",
  nomad: "Projetos Nómada",
  festival: "Festivais",
  workshop: "Oficinas e Laboratórios",
};

export const formatKeys = {
  showcase: "Montra",
  domestic: "Espaço Doméstico",
  industrial: "Espaço Industrial",
  garden: "Jardim",
  kitchen: "Cozinha",
  other: "Outro"
};

export const practiceKeys = {
  plastic_arts: "Artes Plásticas e visuais",
  music_sound: "Música e som",
  theater_performance: "Teatro e Performance",
  cinema_video: "Cinema e Vídeo",
  architecture: "Arquitetura",
  photo: "Fotografia",
  ict: "Ilustração, cerâmica e têxtil", //illustration_ceramics_textile
  edition_printing: "Edição, Impressão e gravura",
  literature: "Literatura e Poesia",
};

export const defaultFilters = {};

export const style = {
  whiteIcon: {
    name: "whitecirclesolid",
    path: "images/markers/white-circle-solid.png",
  },
  whiteClickedIcon: {
    name: "whitecirclestroke",
    path: "images/markers/white-circle-stroke.png",
  },
  icon: {
    name: "limecirclesolid",
    path: "images/markers/lime-circle-solid.png",
  },
  clickedIcon: {
    name: "limecirclestroke",
    path: "images/markers/lime-circle-stroke.png",
  },
};
